import { connect } from 'react-redux';
import actions from 'public/redux/Coordinator/Activities/actions';
import ActivityView from './ActivityView';

const mapStateToProps = ({ CoordinatorActivityForm }) => CoordinatorActivityForm;

const mapDispatchToProps = {
  fetchOne: actions.fetchOne,
  clearOne: actions.clearOne,
};

// connect with redux
export default connect(mapStateToProps, mapDispatchToProps)(ActivityView);
